var ListID = "customization-options-holder";

function SVGViewer(doc) {
  this._Document = doc;

  this._OUM = "EA";

  this._NodeArray = []; // is going to hash the nodes.

  this._RegionObjectArray = [];

  this._PatternTransformHash = [];

  this._ClippingRegions = [];

  // /new stuff
  this._PatternNodeHash = [];

  this._SVGShapes = [
    "rect",
    "circle",
    "ellipse",
    "line",
    "polyline",
    "polygon",
    "path",
    "g",
  ];
}

SVGViewer.prototype.getGraphicalChildrenArray = function (d3Obj) {
  var objNodeArr = [];

  for (var i = 0; i < this._SVGShapes.length; i++) {
    // var nodes = d3Obj.querySelectorAll(this._SVGShapes[i]);
    var nodes = d3Obj.querySelectorAll(this._SVGShapes[i]);

    nodes.forEach((node) => {
      objNodeArr.push(node);
    });

    // if (nodes && nodes[0]) {

    //     console.log('hello')

    //     var resultArr = nodes[0];

    //     for (var u = 0; u < resultArr.length; u++) {

    //         objNodeArr.push(resultArr[u]);

    //     }
    // }
  }

  // console.log('hello: '+objNodeArr.length)

  return objNodeArr;
};

SVGViewer.prototype.parseGraphicalNode = function (node) {
  var returnArr = []; // REGION and TYPE

  // /See if it has an id.
  if (node.attributes) {
    var id = node.attributes.getNamedItem("id");
  } else {
    var id = null;
  }
  if (id) {
    var idString = id.nodeValue;

    // /if its a ID with actual content
    if (idString.length > 1) {
      // /create a region obect for EACH node.
      var region = new RegionObject(idString);

      // if (region.getIsValid()) {
      if (region._isValid) {
        returnArr["REGION"] = region;
        returnArr["TYPE"] = "REGION";
        return returnArr;
      } else {
        // if its a valid clipping path, add to the thing.
        if (region._isClippingPath) {
          var clippingRegion = region;

          returnArr["REGION"] = clippingRegion;
          returnArr["TYPE"] = "CLIP";
          return returnArr;
        } else {
          return null;
        }
      }
    }``
  }
};

SVGViewer.prototype.addRegionToHash = function (region) {
  var node = document.getElementById(region._NodeIdentifier);

  // console.log('region identifier: '+region._NodeIdentifier)

  if (node.tagName == "pattern") {
    return;
  } else {
    if (this._NodeArray[region._Name]) {
      this._NodeArray[region._Name].addIdentifier(region._NodeIdentifier);
    } else {
      //          /MAKE A NEW NODE ENTRY
      this._NodeArray[region._Name] = region;
    }
  }
};

SVGViewer.prototype.sort = function (prop, arr) {
  arr.sort(function (a, b) {
    if (a[prop] < b[prop]) {
      return -1;
    } else if (a[prop] > b[prop]) {
      return 1;
    } else {
      return 0;
    }
  });
};

SVGViewer.prototype.initNodeArray = function () {
  var graphicalNodes = this.getGraphicalChildrenArray(this._Document);

  // console.log('length of graphical nodes: ')
  // console.log(graphicalNodes.length)

  for (var i = 0; i < graphicalNodes.length; i++) {
    var parsedGraphic = this.parseGraphicalNode(graphicalNodes[i]);
    if (parsedGraphic) {
      // //if its a valid region, add it to the hash.

      var regionObj = parsedGraphic["REGION"];

      var type = parsedGraphic["TYPE"];

      if (type == "REGION") {
        this.addRegionToHash(regionObj);
      }
    }
  }
  // /hash and region objects are compiled.
  this._RegionObjectArray = [];

  //  /INITIALIZE THE REGIONS
  for (var i in this._NodeArray) {
    this._NodeArray[i].initRegionObject();
    this._RegionObjectArray.push(this._NodeArray[i]);
  }
  this.sort("_SortOrder", this._RegionObjectArray);
};

SVGViewer.prototype.getRegionObjectArray = function () {
  return this._RegionObjectArray;
};

SVGViewer.prototype.getRegionObjectByID = function (id) {
  if (this._NodeArray[id]) {
    return this._NodeArray[id];
  } else {
    return null;
  }
};

SVGViewer.prototype.setMaterial = function (id, type, value) {
  //material is independant of color.

  var regionObj = this.getRegionObjectByID(id);

  //function(type,colorObj, grainObj, imageObj   ){

  if (regionObj) {
    if (type == "COLOR") {
      regionObj.setMaterial("COLOR", value, null, null);
    }
    if (type == "IMAGE") {
      regionObj.setMaterial("IMAGE", null, null, value);
    }
    if (type == "GRAIN") {
      regionObj.setMaterial("GRAIN", null, value, null);
    }
  }
};

SVGViewer.prototype.setColorByID = function (id, color) {
  var regionObj = this.getRegionObjectByID(id);
  if (regionObj) {
    var fillObjs = document
      .getElementById(this._NodeArray[id]._NodeIdentifier)
      .querySelectorAll("*");

    for (var r = 0; r < fillObjs.length; r++) {
      var obj = fillObjs[r];
      if (obj.getAttribute("fill") != "") {
        obj.setAttribute("fill", color);
        obj.setAttribute("grain", "graintest");
        obj.setAttribute("legendaryID", id + "|COLOR");
      }
    }
  }
};

function clearAllSpecs(){
  setColorAllRegions();
    window.Viewer.getRegionObjectArray().forEach(regionObject => {
    regionObject._MaterialObject.color  = null
    regionObject._MaterialObject.grain = null
  })
  createList(window.Viewer.getRegionObjectArray())
  createSummary()
}

function setColorAllRegions() {
  //for initializing them all white?
  var regionArr = this.Viewer.getRegionObjectArray();

  for (var i = 0; i < regionArr.length; i++) {
    this.Viewer.setColorByID(regionArr[i]._Name, "#ffffff");
  }
}

function returnNotSelectedParts(_Name, _HasGrain, _MaterialObject){
  return   _HasGrain 
              ? !_MaterialObject.color || !_MaterialObject.grain
                  ? 'Color and / or Grain'
                  : false
              : !_MaterialObject.color
                  ? 'Color'
                  : false
}
   

function returnRectangle(){
  return`
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_19_2)">
    <path d="M19.5 0.5H0.5V19.5H19.5V0.5Z" stroke="#D16528"/>
    </g>
    <defs>
    <clipPath id="clip0_19_2">
    <rect width="20" height="20" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  `
}

function returnCheckedMark(){
  return `
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_19_2)">
  <path d="M19.5 0.5H0.5V19.5H19.5V0.5Z" stroke="#D16528"/>
  <path d="M14.9645 6.23399C15.0389 6.30829 15.0979 6.39652 15.1381 6.49364C15.1784 6.59076 15.1991 6.69486 15.1991 6.79999C15.1991 6.90512 15.1784 7.00923 15.1381 7.10635C15.0979 7.20346 15.0389 7.29169 14.9645 7.36599L8.56449 13.766C8.49019 13.8404 8.40196 13.8994 8.30484 13.9396C8.20773 13.9799 8.10362 14.0006 7.99849 14.0006C7.89336 14.0006 7.78926 13.9799 7.69214 13.9396C7.59502 13.8994 7.50679 13.8404 7.43249 13.766L4.23249 10.566C4.08238 10.4159 3.99805 10.2123 3.99805 9.99999C3.99805 9.7877 4.08238 9.5841 4.23249 9.43399C4.3826 9.28388 4.5862 9.19955 4.79849 9.19955C5.01078 9.19955 5.21438 9.28388 5.36449 9.43399L7.99949 12.066L13.8345 6.23399C13.9088 6.15961 13.997 6.1006 14.0941 6.06034C14.1913 6.02008 14.2954 5.99936 14.4005 5.99936C14.5056 5.99936 14.6097 6.02008 14.7068 6.06034C14.804 6.1006 14.8922 6.15961 14.9665 6.23399H14.9645Z" fill="#D16528"/>
  </g>
  <defs>
  <clipPath id="clip0_19_2">
  <rect width="20" height="20" fill="white"/>
  </clipPath>
  </defs>
  </svg>  
  `
}

function partNameSelectStatus({_Name, _HasGrain, _MaterialObject}){
  return `
    <div class="summary-info grid__item">
      <div class = "part-name-and-slect-status">
        <div class= "part-name-and-icon">
          <div class = "part-name">${_Name}</div>
          <div class= "select-status-icon">
            <!-- to-do --- check mark if ALL AVAILABLE optios arare selected -->
            ${
                returnNotSelectedParts(_Name, _HasGrain, _MaterialObject) 
                  ? returnRectangle() 
                  : returnCheckedMark()
            }            
          </div>
        </div>
        <div class = "select-status-text">
          ${ returnNotSelectedParts(_Name, _HasGrain, _MaterialObject) ? 'Not Selected' : ''}
        </div>
      </div>
      <div class = "selected-options">
        Color: ${_MaterialObject.color?.name || '' } ${_HasGrain ? ', Grain: ' : '' } ${_MaterialObject.grain?.name || ''}
      </div>
    </div>
  `
}

function createSummary(){
  let selectedItems = 0
  document.querySelector(".custom-product-summary").innerHTML = `
    <div class = "summary-header">
      <div class= "summary-header-text">
        <h4>YOUR CUSTOM PRODUCT</h4>
      </div>
      <div class= "select-count-holder">
        <span class = "select-count-items"></span>
      </div>
    </div>
    <div class="summary-info-wrapper to">

      ${window.Viewer.getRegionObjectArray().map(regionObject => partNameSelectStatus(regionObject)).join('')}

    </div>
    `
  window.Viewer.getRegionObjectArray().forEach(regionObject => {
      regionObject._MaterialObject.color != null ? selectedItems++ : '' 
      regionObject._MaterialObject.grain != null ? selectedItems++ : ''
  })
  document.querySelector('.select-count').innerHTML = `${selectedItems} item${selectedItems > 1 ? 's' : ''} selected`
  document.querySelector('.select-count-items').innerHTML = `[${selectedItems} item${selectedItems > 1 ? 's' : ''}]`
  
}

function colorOnlyText(partName) {
  return ` <div class = "colorOnlyText"> This ${partName} option has color variants. Please click the button below to discover more.</div>`;
}

function createSelectedImage(cls, part){
  return `
    <img class = "selected-image"
         src = ${ part._MaterialObject[cls] == null
                    ? "https://cdn.shopify.com/s/files/1/0743/1507/1777/files/default_large_15657b3e-b707-451f-99da-5bfce9482389.png?v=1690519629"
                    : part._MaterialObject[cls].image
                }
    />  
  `  
}

function createOption(cls, part) {
  
  return `
      
    <!-- This grid-item becomes grid-parent (not grid__item) if the part has only colour -->  
    <div class= "${ part._HasGrain ? 'grid__item' : 'single-col-grid grid grid--1-col grid--2-col-tablet grid--2-col-desktop' }" > 

      <div class= " ${ part._HasGrain ? 'img-option-col' : 'grid single-option-col' }" >
      <!-- this div alone becomes grid-item if the part has only colour -->
      <div class = "image-button-holder ${ !part._HasGrain ? 'grid__item' : '' } ">

          <div class="selected-image-holder">
            ${createSelectedImage(cls, part)}          
          </div>
          
          <div>
            <div class = "optionClassAndValueHolder">
             <span class = "optionClass"> ${cls}:- </span>
             <span class = "optionValue"> ${part._MaterialObject[cls] == null ? ''  : part._MaterialObject[cls].name } </span> 
            </div>
           
            <div class = "buttonHolder">
              <input type = "hidden" class = "partName" value = "${part._Name}">
              <button class = " btn-select width-100 clipped-btn button button--secondary btn-sm 
                                ${part._MaterialObject[cls] == null ? ''  : 'btn-selected' }
                                ${cls == 'color' ? 'colorSelectButton' : 'grainSelectButton'}
                              "
              >
                ${part._MaterialObject[cls] == null ? 'Select A ' + cls  : 'Change A ' + cls }     
              </button>
            </div>
          </div>
      
      </div>



      
        <!-- this div alone becomes grid-item if the part has only colour --> 
        <div class = "option-class-value-and-select-change-btn  ${ !part._HasGrain ? 'grid__item' : '' } ">
          
          ${
            cls == "color"
              ? part._HasGrain
                ? ""
                : colorOnlyText(part._Name)
              : ""
          }
  
        </div>
      
      </div>
      
    </div>
     
  `;
}

function createEachPart(part) {
  return `
    <div class = "part-name-specs-holder">
      <div class = "part-name-specs">
      
        <h4 class = "partName">${part._Name}</h4>
      
        <div class = "clearSpecsBtnHolder">
          <input type = "hidden" value = "${part._Name}" class = "partName">
          <span class = "clearSpecsBtn">
            <svg xmlns="http://www.w3.org/2000/svg" width="15.75" height="18" viewBox="0 0 15.75 18">
              <path id="trash-solid" d="M4.753.622l-.253.5H1.125a1.125,1.125,0,0,0,0,2.25h13.5a1.125,1.125,0,0,0,0-2.25H11.25L11,.622A1.12,1.12,0,0,0,9.991,0H5.759A1.12,1.12,0,0,0,4.753.622ZM14.625,4.5H1.125L1.87,16.418A1.689,1.689,0,0,0,3.554,18H12.2a1.689,1.689,0,0,0,1.684-1.582Z" fill="#b7b7b7"/>
            </svg>
          <span class = "clearSpecsBtnText"> Clear Specs</sapn></span>
        </div>
      
      </div>
      
      <div class = "optionsHolder ${part._HasGrain ? 'grid--1-col grid grid--2-col-desktop grid--2-col-tablet ':'outer-bordered' }  ">
          
          ${createOption("color", part)}
          
          ${part._HasGrain ? createOption("grain", part) : ""}
       
      </div>
      
    </div>
  `;
}

function assignListenerToSelectButton(selectButtonClass, modalId) {
  document.querySelectorAll(`.${selectButtonClass}`).forEach((selectButton) => {
    selectButton.addEventListener("click", (event) => {
      document.getElementById("selectedPart").value = selectButton
        .closest(".buttonHolder")
        .querySelector(".partName").value;

      displayModal(modalId);
    });
  });
}

function assignListenerToGrainSelectButtons() {
  assignListenerToSelectButton("grainSelectButton", "grain-panel-modal");
}

function assignListenersToColorSelectButtons() {
  assignListenerToSelectButton("colorSelectButton", "color-panel-modal");
}

function assignListenersToSelectButtons() {
  assignListenersToColorSelectButtons();
  assignListenerToGrainSelectButtons();
}

function assignListenersToClearSpecsButtons() {
  document.querySelectorAll(".clearSpecsBtn").forEach((clearSpecsBtn) => {
    clearSpecsBtn.addEventListener("click", (event) => {
      this.Viewer.setColorByID(
        clearSpecsBtn.closest(".clearSpecsBtnHolder").querySelector(".partName")
          .value,
        "#ffffff"
      );
      window.Viewer.getRegionObjectByID(clearSpecsBtn.closest(".clearSpecsBtnHolder").querySelector(".partName").value)._MaterialObject.color = null
      window.Viewer.getRegionObjectByID(clearSpecsBtn.closest(".clearSpecsBtnHolder").querySelector(".partName").value)._MaterialObject.grain = null
      createList(window.Viewer.getRegionObjectArray())
    });
  });
}

function createList(arr) {
document.getElementById(
    this.ListID
  ).innerHTML = '';

  for (let i = 0; i < arr.length; i++) {
    document.getElementById(this.ListID).innerHTML += createEachPart(arr[i]);
  }

  assignListenersToSelectButtons();
  assignListenersToClearSpecsButtons();
  createSummary()
}

function initSVGViewer() {
  //the root DATA OBJECT of the svg
  this.rootNode = document.querySelector("#svg-holder").querySelector("svg");

  // console.log(rootNode)

  this.Viewer = new SVGViewer(this.rootNode);

  this.Viewer.initNodeArray();

  // this.Viewer.initPatterns();

  var arr = this.Viewer.getRegionObjectArray();

  createList(arr);

  setColorAllRegions();

  

  routeClickFromSVG()
}

function routeClickFromSVG(){
  this.Viewer.getRegionObjectArray().forEach(regionObject => {
    regionObject.ListofGraphicalNodesWithFill.forEach(graphicalNodeWithFill => {
      graphicalNodeWithFill.style.cursor = "pointer"
      graphicalNodeWithFill.addEventListener('click', event => {
        document.getElementById("selectedPart").value = regionObject._Name
        displayModal('color-panel-modal');
      })
    })
  })
}






